import type { GameEvent } from "../../engine/types";

export const AMPHIBIAN_EVENTS: readonly GameEvent[] = [
  {
    id: "a_egg_mass",
    archetypes: ["AMPHIBIAN"],
    stages: ["egg"],
    weight: 6,
    text: "คุณเป็นไข่เม็ดเล็กๆ ในวุ้นใส ท่ามกลางพี่น้องอีกนับร้อย",
    choices: [
      {
        label: "รอ",
        outcomes: [
          { chance: 0.85, text: "จุดดำๆ ในไข่ของคุณเริ่มมีหาง", effects: { health: 5 } },
          { chance: 0.15, text: "ปลาตัวหนึ่งเข้ามาตอดกินกลุ่มไข่ไปส่วนหนึ่ง คุณรอดมาได้", effects: { safety: -10 } },
        ],
      },
    ],
  },
  {
    id: "a_tadpole_algae",
    archetypes: ["AMPHIBIAN"],
    stages: ["tadpole"],
    weight: 9,
    text: "แหล่งน้ำของคุณมีตะไคร่น้ำอยู่เต็มไปหมด",
    choices: [
      {
        label: "กินให้อิ่ม",
        outcomes: [
          { chance: 0.8, text: "คุณกินจนตัวกลมป่อง", effects: { fullness: 35 } },
          { chance: 0.2, text: "ตัวอ่อนแมลงปอในน้ำพุ่งเข้ามางับ คุณหนีทันอย่างหวุดหวิด", effects: { fullness: 20, health: -15, cause: "predator" } },
        ],
      },
      { label: "กินอยู่ในกอพืชน้ำ", outcomes: [{ chance: 1, text: "อาหารน้อยกว่าแต่ปลอดภัย", effects: { fullness: 20, safety: 10 } }] },
    ],
  },
  {
    id: "a_pond_drying",
    archetypes: ["AMPHIBIAN"],
    stages: ["tadpole"],
    weight: 3,
    text: "แอ่งน้ำเริ่มตื้นลงทุกวัน",
    choices: [
      { label: "เร่งกินให้โตเร็วๆ", outcomes: [{ chance: 1, text: "คุณโตเร็วขึ้น แต่ร่างกายเหนื่อยล้า", effects: { fullness: 15, health: -5 } }] },
      {
        label: "ว่ายไปตรงที่ลึกที่สุด",
        outcomes: [
          { chance: 0.7, text: "ฝนตกลงมาเติมน้ำทันเวลา", effects: { safety: 5 } },
          { chance: 0.3, text: "น้ำแห้งเร็วกว่าที่คิด คุณติดอยู่ในโคลน", effects: { health: -25, cause: "disaster" } },
        ],
      },
    ],
  },
  {
    id: "a_metamorph",
    opening: true,
    archetypes: ["AMPHIBIAN"],
    stages: ["metamorph"],
    weight: 8,
    text: "ขาของคุณงอกออกมาครบแล้ว",
    choices: [
      {
        label: "ลองขึ้นบก",
        outcomes: [
          { chance: 0.8, text: "อากาศบนบกแปลกใหม่ แต่ปอดของคุณพร้อมแล้ว", effects: { health: 5 } },
          { chance: 0.2, text: "นกกระยางยืนรออยู่ริมน้ำ คุณกระโดดหนีกลับลงน้ำทัน", effects: { safety: -15 } },
        ],
      },
      { label: "อยู่ในน้ำอีกสักพัก", outcomes: [{ chance: 1, text: "คุณรอจนหางหดสั้นลงอีกนิด", effects: { safety: 5 } }] },
    ],
  },
  {
    id: "a_insects",
    archetypes: ["AMPHIBIAN"],
    stageTags: ["adult", "old"],
    weight: 8,
    text: "แมลงตัวหนึ่งบินผ่านหน้าคุณไปมา",
    choices: [
      {
        label: "ยิงลิ้นออกไปงับ",
        outcomes: [
          { chance: 0.75, text: "เข้าเป้า!", effects: { fullness: 30 } },
          { chance: 0.25, text: "พลาด มันบินหนีไปได้", effects: { fullness: -5 } },
        ],
      },
      { label: "รอตัวที่ใหญ่กว่า", outcomes: [{ chance: 1, text: "ตัวใหญ่มาจริงๆ แต่คุณต้องรอนานทีเดียว", effects: { fullness: 20 } }] },
    ],
  },
  {
    id: "a_rain_chorus",
    archetypes: ["AMPHIBIAN"],
    stageTags: ["adult"],
    requires: { notFlags: ["has_mate"] },
    weight: 6,
    text: "ฝนแรกของฤดูตกลงมา เสียงร้องดังระงมไปทั่วทุ่ง",
    choices: [
      {
        label: "ร้องเรียกคู่ให้ดังที่สุด",
        outcomes: [
          { chance: 0.6, text: "เสียงของคุณดึงดูดคู่ได้สำเร็จ", effects: { addFlags: ["has_mate"] } },
          { chance: 0.4, text: "เสียงของคุณดึงดูดงูมาแทน", effects: { safety: -20 } },
        ],
      },
      { label: "เงียบไว้", outcomes: [{ chance: 1, text: "คุณปลอดภัย แต่คืนนี้ไม่มีใครสนใจคุณ", effects: { safety: 5 } }] },
    ],
  },
];
